import { render, staticRenderFns } from "./Congrats.vue?vue&type=template&id=f6e8f052"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"
import style0 from "./Congrats.vue?vue&type=style&index=0&id=f6e8f052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports